module.exports = __webpack_public_path__ + "img/logo-dzm3.270019fd.jpg";